import React, { useEffect, useRef, useState } from 'react';

// Content stays readable without observation, scripts, or motion support.
// Only elements entering the viewport animate; there is no page-wide timer.
export default function BootcampReveal({
  children,
  delay = 0,
  as: Tag = 'div',
  className = '',
  ...rest
}) {
  const ref = useRef(null);
  const [entered, setEntered] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        setEntered(true);
        observer.disconnect();
      },
      { threshold: 0.08, rootMargin: '0px 0px -24px 0px' },
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <Tag
      ref={ref}
      className={`ck-reveal is-visible v2-reveal ${entered ? 'v2-entered' : ''} ${className}`.trim()}
      style={{ '--v2-stagger': `${Math.min(delay, 160)}ms` }}
      {...rest}
    >
      {children}
    </Tag>
  );
}
